import { graphqlSdk } from '../../../../Utils/graphql-client';
import { SupportedLanguage } from '../../../../Utils/graphql-sdk';

export const loadBookingMinimalShop = async (shopId: string) => {
  console.log('loadBookingMinimalShop', shopId);
  const shop = await graphqlSdk.booking_getMinimalShop({ shopId });
  return shop.getShop;
};

export const loadBookingUspBannerEntries = async (
  shopId: string,
  language: SupportedLanguage
) => {
  console.log('loadBookingUspBannerEntries', shopId, language);
  const uspBannerEntries = await graphqlSdk.getUspBannerEntries({
    shopId,
    language,
  });
  return uspBannerEntries.getUspBannerEntries;
};

export const loadBookingDockingLocations = async (shopId: string) => {
  console.log('loadBookingDockingLocations', shopId);
  const dockingLocations = await graphqlSdk.getDockingLocations({ shopId });
  return dockingLocations.getDockingLocationsByShopId;
};

export const loadBookingShop = async (shopId: string, language: SupportedLanguage) => {
  console.log('loadBookingShop', shopId);
  const shop = await graphqlSdk.booking_getShop({ shopId, language });
  return shop.getShop;
};
